import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { Provider } from "react-redux";
import store from "./redux/store";
import "./index.css";
import { ThemeProvider } from "@mui/material";
import theme from "./theme/theme";
import axios from "axios";
import { installAuthInterceptors } from "./shared/utils";

// Token de usuario en toda llamada a los backends propios + re-login al vencer.
installAuthInterceptors(axios);

ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </Provider>,
  document.getElementById("root")
);
